module.exports = __webpack_public_path__ + "img/08_BC9_gobble_the_landscape.f543ac9e.jpg";